import { useState } from "react";
import { Link } from "react-router-dom";
import Login from "../Navbar/Auth/Login";


const NotLoggedIn = () => {
    const [loginOpen, setLoginOpen] = useState(false);
    return (
        <>
            <div style={{ height: "90vh" }} className='d-flex flex-wrap w-100 justify-content-center align-items-center'>
                <div className='text-center small'>
                    <img alt="logo" style={{ objectFit: "contain", height: "20vh", width: "20vh" }} src="/assets/images/logo.png" />
                    <p>You are not logged in. Please <span onClick={() => { setLoginOpen(true); }} className="cursor-pointer text-primary">login</span> to view page content.</p>
                    <p>Go back to <Link to="/">home</Link></p>
                </div>
            </div>
            <Login isOpen={loginOpen} onClose={() => { setLoginOpen(false); }} />
        </>
    );
}

export default NotLoggedIn;